import { memo } from 'react';
import { Theme } from '@mui/material/styles';
import { Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import HelpInfoWrapper from '../../../../../common/help-info-wrapper';
import { formatToAmount } from '../../../../../../constants/helpers/utils';

interface StyleProps {
  variant: 'h3' | 'h4';
}

const useStyles = makeStyles((theme: Theme) => ({
  helpIcon: {
    color: ({ variant }: StyleProps) => theme.typography[variant].color
  }
}));

interface Props {
  label: string;
  amount: number | null;
  variant?: 'h3' | 'h4';
  tooltip?: string;
  useColor?: boolean;
}

const BillingInformationRow = ({ label, amount, variant = 'h4', tooltip, useColor = false }: Props) => {
  const classes = useStyles({ variant });

  const textColor = () => {
    if (amount) {
      if (amount > 0 && useColor) return 'primary';
      if (amount < 0 && useColor) return 'error';
    }

    return null;
  };

  return (
    <Box display="flex" justifyContent="space-between" mb={2}>
      {tooltip ? (
        <HelpInfoWrapper tooltip={tooltip} className={classes.helpIcon} tooltipPlacement="bottom">
          <Typography variant={variant}>{label}</Typography>
        </HelpInfoWrapper>
      ) : (
        <Typography variant={variant}>{label}</Typography>
      )}
      <Typography data-testid={`${label.replace(' ', '-')}-value`} variant={variant} color={textColor() || undefined}>
        {formatToAmount(amount)}
      </Typography>
    </Box>
  );
};

export default memo(BillingInformationRow);
